import { Injectable, effect, signal } from '@angular/core';

export interface CalculatedSignalDef {
    id: string;
    name: string;
    unit: string;
    formula: string;
    precision: number;
}

const storageKey = 'calculatedSignals';

@Injectable({ providedIn: 'root' })
export class CalculatedSignalProvider {
    signals = signal<CalculatedSignalDef[]>([]);

    constructor() {
        this.load();

        // Auto-save whenever signals are updated
        effect(() => {
            const currentSignals = this.signals();
            window.localStorage.setItem(storageKey, JSON.stringify(currentSignals));
        });
    }

    addSignal(def: Omit<CalculatedSignalDef, 'id'>) {
        const id = 'calc_' + Date.now() + '_' + Math.floor(Math.random() * 1000);
        const newSig: CalculatedSignalDef = { ...def, id };
        this.signals.update((s) => [...s, newSig]);
        return id;
    }

    updateSignal(id: string, def: Omit<CalculatedSignalDef, 'id'>) {
        this.signals.update((sigs) => sigs.map((s) => (s.id === id ? { ...def, id } : s)));
    }

    removeSignal(id: string) {
        this.signals.update((sigs) => sigs.filter((s) => s.id !== id));
    }

    private load() {
        try {
            const saved = window.localStorage.getItem(storageKey);
            if (saved) {
                const parsed = JSON.parse(saved);
                if (Array.isArray(parsed)) {
                    this.signals.set(parsed);
                }
            }
        } catch (err) {
            console.error('Failed to load calculated signals from storage', err);
        }
    }
}
